import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useConfig } from '@hummingbirdtechgroup/wings-config';
import { showIntercomMessenger } from '@hummingbirdtechgroup/wings-intercom';
import { makeStyles, Logo, Typography, AnalyticsIcon, MapIcon, LogoutIcon, DroneIcon, HelpIcon, SettingsIcon, TractorSprayerIcon, } from '@hummingbirdtechgroup/wings-ui';
import { logoutRedirect } from '@hummingbirdtechgroup/wings-auth';
import NavBar from './NavBar';
import NavItem from './NavItem';
const useStyles = makeStyles(({ palette, spacing }) => ({
    navigation: { overflow: 'hidden' },
    logoWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    hbLogo: {
        height: spacing(6),
        width: spacing(6),
        margin: spacing(0.5, 0),
    },
    applicationWindow: {
        marginLeft: spacing(7),
        flexGrow: 1,
        height: '100vh',
        overflow: 'hidden',
    },
    version: {
        color: palette.text.secondary,
        opacity: 0.5,
        textAlign: 'center',
    },
    mainIcon: {
        height: spacing(4),
        width: spacing(4),
    },
    secondaryIcon: {
        height: spacing(4),
        width: spacing(4),
        color: palette.grey.lighter,
    },
}));
function checkLocation(location) {
    return window.location.href.includes(location);
}
function Navigation({ children, isAdmin, canUpload, }) {
    const classes = useStyles();
    const { appUrl, applicationUrl, uploaderUrl, accountsUrl, adminUrl } = useConfig();
    return (React.createElement(React.Fragment, null,
        React.createElement(NavBar, { className: classes.navigation },
            React.createElement("section", null,
                React.createElement("section", { className: classes.logoWrapper },
                    React.createElement("div", { className: classes.hbLogo },
                        React.createElement(Logo, null))),
                React.createElement(NavItem, { to: appUrl, selected: checkLocation(`${appUrl}/map`), icon: React.createElement(MapIcon, { className: classes.mainIcon }), label: React.createElement(FormattedMessage, { id: "navigation.map", defaultMessage: "Map" }) }),
                React.createElement(NavItem, { to: `${appUrl}analytics`, selected: checkLocation(`${appUrl}analytics`), icon: React.createElement(AnalyticsIcon, { className: classes.mainIcon }), label: React.createElement(FormattedMessage, { id: "navigation.analytics", defaultMessage: "Analytics" }) }),
                React.createElement(NavItem, { to: applicationUrl, selected: checkLocation(applicationUrl), icon: React.createElement(TractorSprayerIcon, { className: classes.mainIcon }), label: React.createElement(FormattedMessage, { id: "navigation.applications", defaultMessage: "Applications" }) })),
            React.createElement("section", null,
                React.createElement(NavItem, { onClick: showIntercomMessenger, selected: checkLocation(adminUrl), hoverable: false, icon: React.createElement(HelpIcon, { className: classes.secondaryIcon }), label: "Live Chat" }),
                isAdmin ? (React.createElement(NavItem, { to: `${appUrl}admin`, hoverable: false, icon: React.createElement(SettingsIcon, { className: classes.secondaryIcon }), label: "Farm Settings" })) : null,
                canUpload ? (React.createElement(NavItem, { to: uploaderUrl, variant: "anchor", hoverable: false, icon: React.createElement(DroneIcon, { className: classes.secondaryIcon }), label: React.createElement(FormattedMessage, { id: "navigation.upload", defaultMessage: "Upload" }) })) : null,
                React.createElement(NavItem, { onClick: () => logoutRedirect(accountsUrl), icon: React.createElement(LogoutIcon, { className: classes.secondaryIcon }), hoverable: false, label: React.createElement(FormattedMessage, { id: "navigation.logout", defaultMessage: "Logout" }) }),
                React.createElement(Typography, { className: classes.version, variant: "caption" }, `v${process.env.APP_VERSION}`))),
        React.createElement("main", { className: classes.applicationWindow }, children)));
}
export default Navigation;
//# sourceMappingURL=Navigation.js.map